// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__xIjqU","navigation-list":"Navigation_navigation-list__j0a69"};